import React from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa'

function Blog() {
  return (
    <Container>
        <div className='mb-4'>
         <Card style={{ width: '78rem', border:"none" }}>
      <Card.Img variant="top" src="https://cdn.shopify.com/s/files/1/0626/5209/files/stilenben_3.jpg?3577612155944146263" style={{height:"70vh"}} />
      <Card.Body>
        <Card.Title className='blogTitle'>Comfort Dressing: The nostalgic value of the high jewelry</Card.Title>
        <Card.Text>
        The way you declutter and organize your home office directly affects your productivity and happiness.Whether you’re a student, stay-at-home parent, homeschooler, freelancer or executive, organization, it’s time to take control of your workspace! Discover 10 tips from highly...
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>
    </div>

    <Row className='mt-5'>
    <Col style={{height:"35vh"}}  data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="200">
         <Card style={{ width: '18rem',border:"none",boxShadow:"none"  }}>
      <Card.Img variant="top" src="https://demo2.prestabrain.com/stationero/wp-content/uploads/2022/03/blog-7-1000x565.jpg" />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>Brighten Up!</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        The way you declutter and organize your home office directly affects your productivity and happiness....
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>
    </Col>
    <Col data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="350">
    <div>
         <Card style={{ width: '18rem',border:"none",boxShadow:"none" }}>
      <Card.Img variant="top" src="https://demo2.prestabrain.com/stationero/wp-content/uploads/2022/03/blog-5-1000x565.jpg" style={{height:"34vh"}} />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>The Story Behind Our Planners</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        The way you declutter and organize your home office directly affects your productivity and happiness...
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>
    </div>
    </Col>

    <Col data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="500">
    <div>
         <Card style={{ width: '18rem',border:"none",boxShadow:"none"  }}>
      <Card.Img variant="top" src="https://cdn.shopify.com/s/files/1/0626/5209/files/letter_ex.jpg?v=1624542734" />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>Brighten Up!</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        The way you declutter and organize your home office directly affects your productivity and happiness....
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>
    </div>
    </Col>

    <Col data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="700">
         <Card style={{ width: '18rem',border:"none",boxShadow:"none" }}>
      <Card.Img variant="top" src="https://cdn.shopify.com/s/files/1/0626/5209/files/JT_Blog_Image_Kirsty_Thomas-10_1__blogex.jpg?v=1638274620" style={{height:"34vh"}} />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>The Story Behind Our Planners</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        The way you declutter and organize your home office directly affects your productivity and happiness...
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>
    </Col>

    <Col data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="850">
         <Card style={{ width: '18rem',border:"none",boxShadow:"none"  }}>
      <Card.Img variant="top" src="http://cdn.shopify.com/s/files/1/0626/5209/files/blog_2.jpg?v=1542627826" />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>Brighten Up!</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        The way you declutter and organize your home office directly affects your productivity and happiness....
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>

    </Col>

    <Col data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="1100">
         <Card style={{ width: '18rem',border:"none",boxShadow:"none" }}>
      <Card.Img variant="top" src="https://cdn.shopify.com/s/files/1/0626/5209/files/unlimited_ex_4b38def9-7094-43e5-92d3-69042f3fb8d5.jpg?15685043269210702853" style={{height:"55vh"}} />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>The Story Behind Our Planners</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        The way you declutter and organize your home office directly affects your productivity and happiness...
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>
    
    </Col>

    <Col data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="1200">
    
         <Card style={{ width: '18rem',border:"none",boxShadow:"none"  }}>
      <Card.Img variant="top" src="https://cdn.shopify.com/s/files/1/0626/5209/files/crail_excerpt.jpg?3609884679083538716" />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>Meet the Makers: Crail Pottery</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        We meet Ben at Crail Pottery for a studio tour and chat about kayaks, inspirations and working with family.
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>

    </Col>

    <Col data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="1300">
         <Card style={{ width: '18rem',border:"none",boxShadow:"none"  }}>
      <Card.Img variant="top" src="https://cdn.shopify.com/s/files/1/0626/5209/files/crail_excerpt.jpg?3609884679083538716" />
      <Card.Body className='p-0'>
        <Card.Title style={{float:"left",fontSize:"1rem",marginTop:"11px"}}>Meet the Makers: Crail Pottery</Card.Title>
        <Card.Text style={{float:"left",textAlign:"initial",marginTop:"10px"}}>
        We meet Ben at Crail Pottery for a studio tour and chat about kayaks, inspirations and working with family.
        </Card.Text>
        <button className='blogread-button'>Read More<FaPlus className='readArrow'></FaPlus></button>
      </Card.Body>
    </Card>

    </Col>
</Row>
    
    </Container>
  )
}

export default Blog